<ng-container *ngIf="workflowForm$ | async as workflow">
    <app-top-bar [logo]="(sale$ | async)?.store?.logo"></app-top-bar>

    <div class="relative container d-flex flex-column flex-grow" *ngIf="form && workflow.steps">
        <app-stepper #stepper [steps]="workflow.steps" [linear]="true" [currentStep]="(queryStep$ | async) || 0"></app-stepper>

        <div
            class="summary-top-action d-flex justify-content-center mt-3 mb-3"
            *ngIf="stepper.currentStepObj?.slug === 'summary' && (stepper.currentStep + 1) !== stepper.steps.length"
        >
            <button class="button wide" type="button" (click)="next()">
                Finish
            </button>
        </div>

        <ng-container *ngIf="(sale$ | async) as sale">
            <div
                *ngIf="sale.completed && stepper.currentStepObj.slug !== 'summary' && stepper.currentStepObj.slug !== 'final_step'"
                class="overlay"
            >
                <span class="overlay-text top-0">This sale is marked as completed. Editing is not allowed.</span>
                <span class="overlay-text bottom-0">This sale is marked as completed. Editing is not allowed.</span>
            </div>
        </ng-container>

        <div class="step-container flex flex-column flex-grow position-relative w-100">
            <ng-container *ngFor="let step of workflow.steps; let i = index">
                <ng-container [ngSwitch]="step.slug">

                    <ng-container *ngSwitchCase="'terms'">
                        <app-step-display-terms *ngIf="stepper.currentStep === i" class="steps" [step]="step" [formGroup]="form | stepForm: i" [workflow]="workflow" [sale]="(sale$ | async)!"></app-step-display-terms>
                    </ng-container>

                    <ng-container *ngSwitchCase="'html'">
                        <app-step-display-html *ngIf="stepper.currentStep === i" class="steps" [step]="step"></app-step-display-html>
                    </ng-container>

                    <ng-container *ngSwitchCase="'form'">
                        <app-step-display-form *ngIf="stepper.currentStep === i" class="steps" [step]="step" [formGroup]="form | stepForm: i"></app-step-display-form>
                    </ng-container>

                    <ng-container *ngSwitchCase="'video'">
                        <app-step-display-video *ngIf="stepper.currentStep === i" class="steps" [step]="step" [formGroup]="form | stepForm: i" [sale]="(sale$ | async)!"></app-step-display-video>
                    </ng-container>

                    <ng-container *ngSwitchCase="'products'">
                        <app-step-display-products *ngIf="stepper.currentStep === i" class="steps products-step" [workflow]="workflow" [class.has-cart]="cart.items.length" [step]="step" [formGroup]="form | stepForm: i" [sale]="(sale$ | async)!"></app-step-display-products>
                    </ng-container>

                    <ng-container *ngSwitchCase="'promotion'">
                        <app-step-display-promotion *ngIf="stepper.currentStep === i" class="steps" [step]="step" [formGroup]="form | stepForm: i" [sale]="(sale$ | async)!" (prizeClaimed)="next()"></app-step-display-promotion>
                    </ng-container>

                    <ng-container *ngSwitchCase="'summary'">
                        <app-step-display-summary *ngIf="stepper.currentStep === i" class="steps" [step]="step" [steps]="workflow.steps" [sale]="(sale$ | async)!" (couponApplied)="refresh()"></app-step-display-summary>
                    </ng-container>

                    <ng-container *ngSwitchCase="'final_step'">
                        <app-step-display-final *ngIf="stepper.currentStep === i" class="steps" [step]="step"></app-step-display-final>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <!-- Can provide some kind of fall back scenario? -->
                    </ng-container>
                </ng-container>
            </ng-container>

            <div class="full-width justify-between d-flex mt-5 mb-5" *ngIf="(stepper.currentStep + 1) !== stepper.steps.length">
                <button
                    class="button secondary"
                    type="button"
                    (click)="stepper.previous()"
                    [disabled]="this.stepper.currentStep === 0"
                >
                    <i class="far fa-arrow-left"></i>
                    Previous Step
                </button>

                <button
                    class="button"
                    type="button"
                    (click)="next()"
                >
                    Next
                    <i class="far fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="sale$ | async as sale">
    <ng-container *ngIf="!sale.completed && stepper?.steps">
        <app-slide-out [class.slide]="slideOut" [slideOut]="slideOut" (isShowing)="slideOut = false">
            <app-cart-list
                [sale]="sale"
                [steps]="stepper?.steps!">
            </app-cart-list>
        </app-slide-out>

        <div class="flex justify-content-center cart-wrapper" [class.move]="slideOut">
            <div class="flex justify-content-end full-width container">
                <app-cart *ngIf="stepper?.currentStepObj?.slug === 'products'" [cart]="cart" (seeTotal)="slideOut = !slideOut"></app-cart>
            </div>
        </div>
    </ng-container>
</ng-container>
